export default "__VITE_PUBLIC_ASSET__4aa490eb__"